export { default as PostFragment } from './BlogPost';